var map = {
	"./HeroMusic.vue": [
		"8762",
		"chunk-8920e28e",
		"chunk-3bc885e2"
	],
	"./IntroFour.vue": [
		"b247",
		"chunk-8920e28e",
		"chunk-56656654"
	],
	"./test.vue": [
		"b3d9",
		"chunk-1d63ebb7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "995e";
module.exports = webpackAsyncContext;